import React from 'react';
import { connect } from 'react-redux';
import { Card, CardBlock, CardTitle , Button, DropdownItem , DropdownMenu , Nav , NavItem, Dropdown , DropdownToggle} from 'reactstrap';


import ReactTable from "react-table";
import "react-table/react-table.css";
import IconEdit from 'react-icons/lib/md/edit';
import IconPersonAdd from 'react-icons/lib/md/person-add';

import * as actions from '../../actions/inventario';
import Modal from "./Modal";
import Consultas from "./ModalKardexArticulo";

import {api, request, API_URL} from '../../actions/_request';
import moment from 'moment';
import swal from 'sweetalert2';



const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };
class Inventario extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            modal       : false,
            prospectoid : null,
            title       : "",
            modal_consulta:false,
            seleccion_id:null,
            seleccion:[],
            consulta_id:0,
            altas:false,
            bajas:false,
            cambios:false,
            reportes:false,
        };
        this.toggle 			= this.toggle.bind(this);
        this.handleChangecheckbox       = this.handleChangecheckbox.bind(this);
        this.opciones       = this.opciones.bind(this);
        this.toggle_drop       = this.toggle_drop.bind(this);
        this.toggle_consulta            = this.toggle_consulta.bind(this);

    }

     opciones(  tipo=0)
    {
        // this.props.formulario(id,title,tipo);

        if(tipo!=5&&tipo!=6&&tipo!=1&&this.state.seleccion_id==null){

            swal("Oops..", "Por favor Seleccione un Articulo");

        }else{
             switch (tipo) {
                case 1:
                   window.open(API_URL+"/consulta_inventario_completo/1");
                    break;
                case 5:
                   window.open(API_URL+"/consulta_inventario_completo/3");
                    break;
                case 6:
                   window.open(API_URL+"/consulta_inventario_completo/2");
                    break;
                
                default:
                     this.toggle_consulta(null,tipo);
                    break;
            }
        }

       
    }

  toggle_drop(menu,id) {
    let valor=0;

    if(menu===1){
      if(parseInt(this.state.menu)!==id)
        valor=id;
        this.setState({
          menu: valor
        });
    }else{
      if(parseInt(this.state.submenu)!==id)
        valor=id;
        this.setState({
          submenu: valor
        });
    }
  }

    handleChangecheckbox(row)
    {
        let data =this.props.inventario.data;     
        let bandera=0;
        this.setState({
            seleccion_id : parseInt( row.original.value),
            seleccion : row.original,
        });  
        }

   toggle(evt, prospectoid = null, title = "Agregar Producto")
    {
        //let {modal} = this.state;

        this.setState({
            modal       : !this.state.modal,
            prospectoid : prospectoid,
            title       : title,
            
        });
    }
    toggle_consulta(evt,consulta_id)
    {
        //let {modal} = this.state;

        this.setState({
            modal_consulta       : !this.state.modal_consulta,
            consulta_id:consulta_id,
            
        });
    }

    componentDidMount() {

        this.props.get();
         if (typeof this.props.auth.permisos === "undefined") {
            
          } else {
           // console.log('permisos--->',this.props.auth.permisos[0])
           let permisos=this.props.auth.permisos[0];
           this.setState({
              altas:parseInt(permisos.altas)===1?true:false,
              bajas:parseInt(permisos.bajas)===1?true:false,
              cambios:parseInt(permisos.cambios)===1?true:false,
              reportes:parseInt(permisos.reportes)===1?true:false,
              });
           
          }

    }

    formateo(value) {
      let etiqueta='$';

      var decimals =  2;
      var  separators =[',', ",", '.'];
      var number = (parseFloat(value) || 0).toFixed(decimals);
      if(number<0)
        etiqueta='$ -';

      if (number.length <= (4 + decimals))
      return etiqueta +number.replace('.', separators[separators.length - 1]);
      var parts = number.split(/[-.]/);
      value = parts[parts.length > 1 ? parts.length - 2 : 0];
      var result = value.substr(value.length - 3, 3) + (parts.length > 1 ?
      separators[separators.length - 1] + parts[parts.length - 1] : '');
      var start = value.length - 6;
      var idx = 0;
      while (start > -3) {
      result = (start > 0 ? value.substr(start, 3) : value.substr(0, 3 + start))
      + separators[idx] + result;
      idx = (++idx) % 2;
      start -= 3;
      }
      return etiqueta + result;
    }

    render() {
      const { altas,bajas,cambios,reportes } = this.state;

        return(
            <div className="view">

        

            

                <div className="view-header">
                    <header className="title text-white">
                        <h1 className="h4 text-uppercase">Inventario</h1>
                    </header>
                </div>

                <div className="view-content view-components">
                    <Card>
                        <CardBlock>

                        <div className="text-right">
                                 { reportes&&
                                <Dropdown nav className='drop_left' isOpen={parseInt(this.state.menu)===1?true:false} toggle={() => {this.toggle_drop(1,1);}} >
                                  <DropdownToggle nav caret>
                                   Consultas
                                  </DropdownToggle>
                                  <DropdownMenu className='letras_menu'>
                                    <DropdownItem onClick={() => {this.opciones(1);}}>Todo el Inventario</DropdownItem>
                                    <DropdownItem onClick={() => {this.opciones(6);}}>Toma de Inventario</DropdownItem>
                                    <DropdownItem onClick={() => {this.opciones(5);}}>Valor del Inventario</DropdownItem>
                                    <DropdownItem onClick={() => {this.opciones(2);}}>Kardex de un Articulo</DropdownItem>
                                    <DropdownItem onClick={() => {this.opciones(3);}}>Articulo Vendido A</DropdownItem>
                                    <DropdownItem onClick={() => {this.opciones(4);}}>Articulo Comprado A</DropdownItem>
                                  </DropdownMenu>
                                </Dropdown> 
                              }
                              { altas&&
                                <Button color="success" className="mb-2" onClick={this.toggle}>
                                    Agregar
                                </Button>
                              }
                            </div>
                            <ReactTable
                            getTrProps={(state, rowInfo, column) => {
                                  
                                  if(rowInfo === undefined){
                                          
                                          return{

                                          }
                                        }else{
                                           return{
                                            onDoubleClick: (evt)=>{
                                              if(cambios){
                                                 this.toggle(evt, rowInfo.original.value, 'Editar Producto')
                                              }else{
                                                 swal('', 'No tienes permisos para editar');
                                              }
                                            }
                                        } 
                                  
                                    }
                              }}
                              data      = {this.props.inventario.data}
                              className = "-striped -highlight"
                              columns   = {[
                                {
                                    Header: 'Seleccion',
                                    filterable: false,
                                    sortable: false,
                                    maxWidth:80,
                                    minWidth:80, 
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-center">
                                                <input type="checkbox"
                                                name="afiliado" 
                                                checked={(this.state.seleccion_id === parseInt( row.original.value)) ? true : false}
                                                onChange={() => this.handleChangecheckbox(row)}/>                                                 
                                            </div>
                                        )
                                    }
                                },
                              
                              
                                {Header: 'Codigo', accessor: 'codigo_interno',maxWidth:150,minWidth:150 , style: { 'textAlign': 'center'}},
                                {Header: 'Codigo Prov.', accessor: 'codigo',maxWidth:150,minWidth:150 , style: { 'textAlign': 'center'}},
                                {Header: 'Descripcion', accessor: 'label',maxWidth:350,minWidth:350 , style: { 'textAlign': 'left'}},
                                {Header: 'Categoria', accessor: 'categoria',maxWidth:350,minWidth:350 , style: { 'textAlign': 'left'}},
                                {Header: 'Existencia', accessor: 'existencia',maxWidth:150,minWidth:150 , style: { 'textAlign': 'center'}},
                                
                                {Header: 'Costo',maxWidth:150,minWidth:150 , style: { 'textAlign': 'right'},
                                  Cell: (row) =>
                                        {
                                            return(
                                              <label>{this.formateo(row.original.costo)}</label>
                                            )
                                        }},
                                {Header: 'Precio 1', accessor: 'credito',maxWidth:150,minWidth:150 , style: { 'textAlign': 'right'},
                                  Cell: (row) =>
                                        {
                                            return(
                                              <label>{this.formateo(row.original.credito)}</label>
                                            )
                                        }},
                                {Header: 'Precio 2', accessor: 'contado',maxWidth:150,minWidth:150 , style: { 'textAlign': 'right'} ,
                                Cell: (row) =>
                                        {
                                            return(
                                              <label>{this.formateo(row.original.contado)}</label>
                                            )
                                        }},
                                {
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                    maxWidth:80,
                                    minWidth:80, 
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-right">
                                                 {cambios&&
                                                <Button
                                                 color="success" 
                                                 className="btn-sm" 
                                                 onClick={(evt)=>this.toggle(evt, row.original.value, 'Editar Producto')}>
                                                    <IconEdit />
                                                </Button>}{' '}
                                                 
                                            </div>
                                        )
                                    }
                                }
                              
                              ]}
                              filterable 
                              defaultPageSize={10} 
                             defaultFilterMethod={filterCaseInsensitive}

                            
                             
                              
                             
                            />
                        </CardBlock>
                    </Card>
                </div>
                {
                   this.state.modal&& 
                   <Modal 
                 open={this.state.modal} 
                 toggle={this.toggle} 
                 title={this.state.title} 
                 prospectoid={this.state.prospectoid}
                />
                }
                 {
                   this.state.modal_consulta&& 
                   <Consultas 
                 open={this.state.modal_consulta} 
                 toggle={this.toggle_consulta} 
                 articulo_id={this.state.seleccion_id}
                 articulo={this.state.seleccion}
                 consulta_id={this.state.consulta_id}
                />
                }
                 

            </div>
        );
    }

};

function mapStateToProps(state, ownProps) {
    return {
        inventario : state.inventario,
        auth:state.auth,
    }
};

export default connect(mapStateToProps, actions)(Inventario)


// WEBPACK FOOTER //
// ./src/views/inventario/index.js